const scrollObserver = (revealItems, onEntry, options = {root: null, rootMargin: "-150px 0px", threshold: 0.05}) => {
    document.addEventListener("DOMContentLoaded", () => {
        if (!revealItems || Number.parseInt(revealItems.length, 10) === 0) {
            return;
        }
        // let options = {root, rootMargin, threshold};
        let observer = new IntersectionObserver(beTouching, options);
        revealItems.forEach(item => {
            observer.observe(item);
        });

        function beTouching(entries, ob) {
            entries.forEach(entry => {
                if (
                    entry.target.classList.contains('speed-boa__video-item')
                    && window.matchMedia('(max-width: 1199px)').matches
                ) {
                    entry.target.querySelector('video').click(); // iOs fix
                } else if (entry.isIntersecting) {
                    entry.target.classList.add("revealed");
                    if (onEntry) onEntry()
                    ob.unobserve(entry.target);
                }
            });
        }
    });
}

export default scrollObserver;
